<template>
  <div class="flex-container">
    <div class="flex-header">
      <div class="header-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/sys/workflow/workflowList' }">流程列表</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/sys/workflow/view/' + flowId }">{{ workflowName }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="header-stats">
          <div class="stats-item">
            <span class="stats-num">{{ totalMerchantNum }}</span>
            <span class="stats-label">商户总数</span>
          </div>
          <span class="stats-divider" />
          <div class="stats-item">
            <span class="stats-num">{{ totalStoreNum }}</span>
            <span class="stats-label">门店总数</span>
          </div>
        </div>
      </div>
      <!-- 搜索区域 -->
      <el-form :inline="true" size="mini" :model="searchForm" class="search-form">
        <el-form-item label="商户名称：">
          <el-input v-model="searchForm.merchantName" clearable placeholder="请输入商户名称" style="width:180px;" />
        </el-form-item>
        <el-form-item label="商户编码：">
          <el-input v-model="searchForm.merchantCode" clearable placeholder="请输入商户编码" style="width:160px;" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- 操作按钮 -->
      <div class="action-bar">
        <el-button size="small" type="primary" @click="addMerchant"><i class="el-icon-plus"></i> 新增商户</el-button>
        <el-button size="small" @click="importMerchant"><i class="el-icon-upload2"></i> 导入商户Excel</el-button>
        <el-button size="small" @click="importStore"><i class="el-icon-upload2"></i> 导入门店Excel</el-button>
      </div>
    </div>

    <div class="flex-item table-wrapper">
      <el-table :data="tableData" border size="small" style="width:100%;" v-loading="tableLoading" :height="tableHeight">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="merchantCode" label="商户编码" width="130" align="center" />
        <el-table-column prop="merchantName" label="商户名称" min-width="160" show-overflow-tooltip />
        <el-table-column prop="contact" label="联系人" width="100" align="center" />
        <el-table-column prop="phone" label="电话" width="130" align="center" />
        <el-table-column prop="storeNum" label="门店数" width="80" align="center" />
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '1' ? 'success' : 'danger'" size="small">
              {{ scope.row.status === '1' ? '正常' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" align="center" />
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewMerchant(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-bar">
      <el-pagination
        @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <div class="form-footer-fixed">
      <el-button size="medium" @click="goBack"><i class="el-icon-back"></i> 返回流程详情</el-button>
      <span class="footer-hint">渠道：{{ workflowName }}</span>
    </div>
  </div>
</template>

<script>
import {mockMerchantsByWorkflow, mockWorkflows} from "./mockWorkflowData";
export default {
  name: "merchantList",
  data() {
    return {
      flowId: '',
      workflowName: '',
      channelName: '',
      totalMerchantNum: 0,
      totalStoreNum: 0,
      allMerchants: [],
      tableData: [],
      tableLoading: false,
      tableHeight: '400px',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: { merchantName: '', merchantCode: '' },
    };
  },
  created() {
    this.flowId = this.$route.params.flowId || '';
    this.loadData();
    this.setTableHeight();
  },
  methods: {
    setTableHeight() {
      if (typeof window !== 'undefined') {
        this.tableHeight = Math.round((window.innerHeight || document.documentElement.clientHeight) * 0.55) + 'px';
      }
    },
    loadData() {
      this.allMerchants = mockMerchantsByWorkflow[this.flowId] || [];
      const wf = mockWorkflows.find(w => w.id === this.flowId);
      if (wf) {
        this.workflow = { ...wf };
        this.workflowName = wf.channelName;
      } else {
        this.workflowName = '流程 ' + this.flowId;
      }
      this.totalMerchantNum = this.allMerchants.length;
      this.totalStoreNum = this.allMerchants.reduce((sum, m) => sum + (m.storeNum || 0), 0);
      this.filterData();
    },
    filterData() {
      let list = [...this.allMerchants];
      const mn = (this.searchForm.merchantName || '').trim();
      const mc = (this.searchForm.merchantCode || '').trim();
      if (mn) list = list.filter(m => m.merchantName.includes(mn));
      if (mc) list = list.filter(m => m.merchantCode.includes(mc));
      this.total = list.length;
      const start = (this.currentPage - 1) * this.pageSize;
      this.tableData = list.slice(start, start + this.pageSize);
    },
    onSearch() { this.currentPage = 1; this.filterData(); },
    onReset() { this.searchForm = { merchantName: '', merchantCode: '' }; this.onSearch(); },
    handleSizeChange(val) { this.pageSize = val; this.currentPage = 1; this.filterData(); },
    handleCurrentChange(val) { this.currentPage = val; this.filterData(); },
    goBack() { this.$router.push('/sys/workflow/view/' + this.flowId); },
    viewMerchant(row) { this.$router.push('/sys/workflow/merchantDetail/' + this.flowId + '/' + row.merchantId); },
    addMerchant() { this.$message.success('新增商户功能（待对接API）'); },
    importMerchant() { this.$message.success('导入商户Excel功能（待对接API）'); },
    importStore() { this.$message.success('导入门店Excel功能（待对接API）'); },
  }
};
</script>

<style scoped>
.flex-container { height: 100%; display: flex; flex-direction: column; text-align: left; }
.flex-header { flex-shrink: 0; background: #fff; padding-bottom: 10px; }
.header-top { display: flex; align-items: center; justify-content: space-between; }
.header-stats { display: flex; align-items: center; gap: 20px; flex-shrink: 0; }
.flex-item:nth-child(2) { flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }
.table-wrapper { flex: 1; min-height: 0; overflow: hidden; }
.stats-item { text-align: center; }
.stats-num { font-size: 20px; font-weight: 700; color: #409EFF; line-height: 1.2; }
.stats-label { font-size: 12px; color: #909399; margin-left: 4px; }
.stats-divider { width: 1px; height: 24px; background: #dcdfe6; }
.search-form { margin-bottom: 8px; }
.action-bar { margin-bottom: 10px; }
.pagination-bar { text-align: right; padding: 8px 0; flex-shrink: 0; }
.form-footer-fixed {
  text-align: center; padding: 16px 0; border-top: 1px solid #ebeef5;
  background: #fff; flex-shrink: 0; position: relative; z-index: 10;
}
.form-footer-fixed .el-button { min-width: 140px; }
.footer-hint { margin-left: 20px; font-size: 13px; color: #909399; }
</style>
